import loadable from '@loadable/component';

import { BoxIndicator } from '@classtinginc/design-system';

const AuthenticationPage = loadable(() => import('./AuthenticationPage'), {
  fallback: <BoxIndicator />,
});

export default AuthenticationPage;
